import * as React from 'react';
import * as cx from 'classnames';
import './ScoreIndicator.css';
import RadialbarChart from './RadialbarChart';

interface Props {
    label: string;
    companyScore: number;
    allCompanyScore: number;
    industryNPS: number;
    hasBorder?: boolean;
    percentageNPS?: boolean;
    negativeNPS?: boolean;
}

const percentageMessage = `Percentage of survey respondents from your industry answering 8, 9, or 10.`;
const NPSMessage = `Net Promoter Score. \n 
                    Number of respondents answering 9 or 10 minus number of respondents answering 0-6`;

function getTenBasedPercent(tenRangeNumber: number): number {
    return tenRangeNumber * 10;
}

function getHundredBasedPercent(decimal: number) {
    return decimal * 100;
}

function firstIndicator(companyScore: number, companyScorePercentile: number) {
    return (
        <div className="score-indicator first-indicator">
            <p>{companyScore}</p>
            <RadialbarChart
                color={'DFA555'}
                percentFill={companyScorePercentile}
            />
        </div>
    );
}

function secondIndicator(allCompanyScore: number, allCompanyScorePercentile: number) {
    return (
        <div className="score-indicator first-indicator">
            <p>{allCompanyScore}</p>
            <RadialbarChart
                color={'2c9452'}
                percentFill={allCompanyScorePercentile}
            />
        </div>
    );
}

function percentageIndicator(satisfactionPercent: number) {
    return (
        <div className="score-indicator">
            <p>{satisfactionPercent}%</p>
            <RadialbarChart
                color={'818181'}
                percentFill={satisfactionPercent}
                tooltipEnabled={true}
                message={percentageMessage}
            />
            <span className="special-score-labels percent-label">%8, 9 or 10</span>
        </div>
    );
}

function NPSIndicator(industryNPS: number) {
    return (
        <div className="score-indicator">
            <p>{industryNPS}</p>
            <RadialbarChart
                color={'818181'}
                percentFill={industryNPS}
                directionalValue={true}
                tooltipEnabled={true}
                message={NPSMessage}
            />
            <span className="special-score-labels">NPS</span>
        </div>
    );
}

class ScoreIndicator extends React.Component<Props> {
    render() {
        const { label, hasBorder, companyScore, allCompanyScore, industryNPS, percentageNPS, negativeNPS } = this.props;

        const sectionClasses = cx('score-section', {
            'middle-border': hasBorder
        });
        const companyScorePercentile = getTenBasedPercent(companyScore);
        const allCompanyScorePercentile = getTenBasedPercent(allCompanyScore);
        const satisfactionPercent = getHundredBasedPercent(industryNPS);

        return (
            <div className={sectionClasses}>
                <h4 className="section-label">{label}</h4>
                {firstIndicator(companyScore, companyScorePercentile)}
                {secondIndicator(allCompanyScore, allCompanyScorePercentile)}
                {percentageNPS && percentageIndicator(satisfactionPercent)}
                {negativeNPS && NPSIndicator(industryNPS)}
            </div>
        );
    }
}

export default ScoreIndicator;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/results/ScoreIndicator.tsx